export default "__VITE_ASSET__DdEStEE1__"